module.exports = __webpack_public_path__ + "img/fp.d40d80c8.png";